import searchAutocompleteHtml from '../views/searchAutocomplete.component.html';

class SearchAutocompleteController {
    constructor($scope, $timeout, $attrs, searchAutocompleteService, spinnerService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.service = searchAutocompleteService;
        this.loading = false;
        this.query = '';
        this.options = [];
        this.debounce = null;
        this.redirect = false;
        this.route = $attrs.frontendRoute;
        this.service.setRoute($attrs.apiRoute);
        this.spinnerId = $attrs.spinnerId;
        this.spinnerService = spinnerService;
    }

    $onInit() {
        this.$scope.$watch(
            () => this.query,
            () => {
                this.refreshMatches();
            }
        );
    }

    refreshMatches() {
        this.loading = true;
        this.options = [];

        if (this.debounce) {
            this.$timeout.cancel(this.debounce);
            this.debounce = null;
        }

        if (this.query == '') {
            this.loading = false;
            this.options = [];

            return;
        }

        this.debounce = this.$timeout(() => {
            this.spinnerService.show('autocomplete' + (this.spinnerId ? '-' + this.spinnerId : ''));
            this.service.matches(this.query).then(
                (response) => {
                    this.loading = true;
                    this.options = response.data.data;
                    this.spinnerService.close('autocomplete' + (this.spinnerId ? '-' + this.spinnerId : ''));
                },
                () => {
                    this.spinnerService.close('autocomplete' + (this.spinnerId ? '-' + this.spinnerId : ''));
                    this.loading = false;
                }
            );
        }, 500);

    }

    submit(query) {
        this.redirect = true;
        window.location.href = `${this.route}/?q=${encodeURIComponent(query)}`;
    }

    select(match) {
        this.redirect = true;
        window.location.href = match.url;
    }
}

let searchAutocompleteComponent = {
    bindings: {},
    template: searchAutocompleteHtml,
    controller: SearchAutocompleteController
}

export default searchAutocompleteComponent;
